<!--Used to display information about all the organisations
and to sort the data and find te related organisation info
In (UI) organisations-> navigation pan in left
-->
<template>
  <v-col
    :cols="!this.drawerCollapsed ? 12 : 1"
    :md="!this.drawerCollapsed ? 3 : ''"
    class="px-0 py-0 fillHeight"
    :style="drawerCollapsed ? 'max-width: 30px' : 'width: inherit'"
  >
    <!--   :sm="sm="1""-->
    <v-card class="leftContentDrawer" elevation="0" color="#58e2c2">
      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="drawerCollapsed"
        color="#58e2c2"
        permanent
        class="leftContentDrawerData"
      >
        <v-btn
          small
          :ripple="false"
          @click.stop="toggleLeftNavigationPan"
          absolute
          fab
          elevation="0"
          color="#58e2c2"
          :style="drawerCollapsed ? 'margin-left: -22px' : 'right: -20px'"
          class="slideOnOffBtn"
          data-test-id="configuration-sidebar__toggle-btn"
        >
          <v-icon class="white--text">{{
            drawerCollapsed ? 'chevron_right' : 'chevron_left'
          }}</v-icon>
        </v-btn>
        <organisation-list v-show="!drawerCollapsed" />
      </v-navigation-drawer>
    </v-card>
  </v-col>
</template>

<script>
import EventBus from '@/EventBus';
import OrganisationList from './OrganisationList';
export default {
  components: {
    OrganisationList
  },
  data() {
    return {
      drawer: true,
      drawerWidth: 300,
      drawerCollapsed: true,
      companiesnameList: [
        'Company name',
        'Longer company name',
        'Small name',
        'Company name',
        'Longer company name',
        'Small name'
      ],
      isSortByNameToggled: false,
      selectedSort: 'sortByName',
      md1: '',
      sm1: ''
    };
  },
  methods: {
    // hide and display the navigation pan
    toggleLeftNavigationPan() {
      let x = true;
      if (!x) {
        return false;
      }
      this.drawerCollapsed = !this.drawerCollapsed;
      localStorage.setItem('leftDrawerOpen', this.drawerCollapsed);
      EventBus.$emit('drawerCollapsed', !this.drawerCollapsed);
      EventBus.$emit('reRenderChart');
    },
    // sort data by name
    handleSortSelectionByname() {
      this.isSortByNameToggled = !this.isSortByNameToggled;
      this.selectedSort = 'sortByName';
    },
    // sort data by user count
    handleSortSelectionByUserCount() {
      this.selectedSort = 'sortByUserCount';
    }
  },
  mounted() {
    if (localStorage.getItem('leftDrawerOpen') !== null) {
      this.drawerCollapsed = JSON.parse(localStorage.getItem('leftDrawerOpen'));
    }
    const leftPanelCols = 3;
    const pageCols = 12;
    this.md1 = !this.drawerCollapsed ? undefined : leftPanelCols;
    this.sm1 = !this.drawerCollapsed ? 1 : pageCols;
  }
};
</script>
